import type {AxiosPromise} from 'axios'
import axios, {CancelToken} from '@/plugin/axios'
import api from '@/api'
const cancelFn: Record<string, (reason?: string) => void> = {}

export const troubleshooting = {
  troubleshootingSessionStart,
  troubleshootingSessionResume,
  fetchTroubleshootingGuides,
  fetchTroubleshootingTopGuides,
  fetchTroubleshootingSessionList,
  fetchTroubleshootingSettings,
  troubleshootingSessionSummary,
  troubleshootingSessionSummaryPDF,
  fetchFaultCodesDetails
}

function troubleshootingSessionStart(
  _sn: string,
  _guideId: string,
  _postParameters: Record<string, any> = {},
  region: string,
  locale: string
): AxiosPromise {
  if (typeof cancelFn['troubleshootingSessionList'] === 'function') cancelFn['troubleshootingSessionList']('isCancelled')
  return axios.post(
    api.endpoints.DPMM_API.TROUBLESHOOTING_SESSION_START
      .replace('{serial}', _sn)
      .replace('{guide_id}', _guideId),
    _postParameters,
    {
      params: {business_unit: region.toUpperCase(), locale},
      cancelToken: new CancelToken(function executor(c) { cancelFn['troubleshootingSessionList'] = c })
    }
  )
}

function troubleshootingSessionResume(
  _sessionId: string,
  _postParameters: Record<string, any> = {},
  region: string,
  locale: string
): AxiosPromise {
  return axios.post(
    api.endpoints.DPMM_API.TROUBLESHOOTING_SESSION_RESUME.replace('{session_id}', _sessionId),
    _postParameters,
    {params: {business_unit: region.toUpperCase(), locale}}
  )
}

function fetchTroubleshootingTopGuides(_sn: string, _postParameters: Record<string, any>): AxiosPromise {
  return axios.get(api.endpoints.DPMM_API.TROUBLESHOOTING_TOP_GUIDES_LIST.replace('{serial}', _sn), _postParameters)
}

function fetchTroubleshootingGuides(_sn: string, _postParameters: Record<string, any>): AxiosPromise {
  return axios.get(api.endpoints.DPMM_API.TROUBLESHOOTING_GUIDES_LIST.replace('{serial}', _sn), _postParameters)
}

function fetchTroubleshootingSettings(_sn: string): AxiosPromise {
  if (typeof cancelFn['fetchTroubleshootingSettings'] === 'function') cancelFn['fetchTroubleshootingSettings']('isCancelled')
  return axios.get(api.endpoints.DPMM_API.TROUBLESHOOTING_SETTINGS.replace('{serial}', _sn), {
    cancelToken: new CancelToken(function executor(c) { cancelFn['fetchTroubleshootingSettings'] = c })
  })
}

function fetchTroubleshootingSessionList(_sn: string): AxiosPromise {
  if (typeof cancelFn['troubleshootingSessionList'] === 'function') cancelFn['troubleshootingSessionList']('isCancelled')
  return axios.get(api.endpoints.DPMM_API.TROUBLESHOOTING_SESSION_LIST.replace('{serial}', _sn), {
    cancelToken: new CancelToken(function executor(c) { cancelFn['troubleshootingSessionList'] = c })
  })
}

function troubleshootingSessionSummary(_sessionId: string, _region: string): AxiosPromise {
  return axios.get(
    api.endpoints.DPMM_API.TROUBLESHOOTING_SESSION_SUMMARY.replace('{session_id}', _sessionId),
    {params: {business_unit: _region.toUpperCase()}}
  )
}

async function troubleshootingSessionSummaryPDF(_sessionId: string): AxiosPromise {
  return axios.get(
    api.endpoints.DPMM_API.TROUBLESHOOTING_SESSION_SUMMARY_PDF.replace('{session_id}', _sessionId),
    {responseType: 'blob'}
  )
}

function fetchFaultCodesDetails(code: string, family_id: string, lang: string): AxiosPromise {
  return axios.get(api.endpoints.DPMM_API.FAULT_CODE_DETAILS.replace('{code}', code), {
    params: {family_id, lang}
  })
}
